export default (that) => [
  {
    text: that.$l('menu_text_detail') || '查看报价',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('menu_text_edit') || '编辑报价',
    icon: 'el-icon-edit',
    menuType: 'edit',
    allow: 'M',
    disabled: ({ quotationStatus }) => !['N'].includes(quotationStatus),
  },
  {
    text: that.$l('menu_text_delete') || '删除报价',
    icon: 'el-icon-delete',
    menuType: 'delete',
    divided: true,
    allow: 'D',
    disabled: ({ quotationStatus }) => !['N'].includes(quotationStatus),
  },
  {
    text: that.$l('menu_text_audit') || '审核报价',
    icon: 'el-icon-s-check',
    menuType: 'audit',
    allow: 'C',
    disabled: ({ quotationStatus }) => !['N'].includes(quotationStatus),
  },
]
